import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { C, font } from "../tokens";

/**
 * Banner de consentimento de cookies (i0 no build).
 *
 * NOTA: o build de produção persiste a escolha em localStorage. Por convenção
 * do projeto (ver CLAUDE.md), NÃO usamos localStorage — o estado vive apenas em
 * useState, então a escolha não persiste entre recarregamentos. Mantivemos o
 * ouvinte do evento `imobmeet:open-cookie-consent` (reabre o banner) e o
 * disparo de `imobmeet:cookie-consent` (usado por outras integrações).
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Sem localStorage: exibe sempre ao montar.
    setVisible(true);
    const o = () => setVisible(true);
    window.addEventListener("imobmeet:open-cookie-consent", o);
    return () => window.removeEventListener("imobmeet:open-cookie-consent", o);
  }, []);

  const decide = (choice) => {
    try {
      window.dispatchEvent(
        new CustomEvent("imobmeet:cookie-consent", { detail: choice })
      );
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Consentimento de cookies"
      style={{
        position: "fixed",
        left: 20,
        bottom: 20,
        zIndex: 300,
        width: "min(430px, calc(100vw - 40px))",
        background: C.surface,
        border: `1px solid ${C.border}`,
        borderRadius: 18,
        boxShadow: "0 24px 60px rgba(10,15,30,0.22)",
        padding: "22px 22px 20px",
        fontFamily: font,
        animation: "slide-up-fade 0.35s cubic-bezier(.16,1,.3,1) both",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 11, marginBottom: 12 }}>
        <span
          style={{
            width: 40,
            height: 40,
            borderRadius: 12,
            flexShrink: 0,
            background: `${C.accent}14`,
            color: C.accent,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5z" />
            <path d="M8.5 9.5h.01M15 9h.01M9 15h.01M14.5 14.5h.01M12 12h.01" />
          </svg>
        </span>
        <h3
          style={{
            fontFamily: font,
            fontSize: 16.5,
            fontWeight: 800,
            letterSpacing: -0.3,
            color: C.text,
            margin: 0,
          }}
        >
          Controle sua privacidade
        </h3>
      </div>
      <p
        style={{
          fontFamily: font,
          fontSize: 14,
          lineHeight: 1.6,
          color: C.muted,
          margin: "0 0 14px",
        }}
      >
        Usamos cookies para melhorar a sua navegação, analisar o tráfego e personalizar
        conteúdo. Ao clicar em “Aceitar”, você concorda com o uso de cookies.
      </p>
      <Link
        to="/politica-de-privacidade"
        onClick={() => setVisible(false)}
        style={{
          fontFamily: font,
          fontSize: 13.5,
          fontWeight: 700,
          color: C.accent,
          textDecoration: "none",
          display: "inline-block",
          marginBottom: 18,
        }}
      >
        Política de Privacidade
      </Link>
      <div style={{ display: "flex", gap: 10 }}>
        <button
          onClick={() => decide("rejected")}
          style={{
            flex: 1,
            padding: "12px 14px",
            borderRadius: 11,
            cursor: "pointer",
            background: C.surface,
            border: `1.5px solid ${C.border}`,
            color: C.text,
            fontFamily: font,
            fontSize: 14.5,
            fontWeight: 700,
            transition: "border-color 0.2s, background 0.2s",
          }}
          onMouseEnter={(o) => {
            o.currentTarget.style.borderColor = C.muted;
          }}
          onMouseLeave={(o) => {
            o.currentTarget.style.borderColor = C.border;
          }}
        >
          Rejeitar
        </button>
        <button
          onClick={() => decide("accepted")}
          style={{
            flex: 1,
            padding: "12px 14px",
            borderRadius: 11,
            cursor: "pointer",
            background: C.accent,
            border: "none",
            color: "#fff",
            fontFamily: font,
            fontSize: 14.5,
            fontWeight: 800,
            boxShadow: "0 8px 22px rgba(5,96,255,0.28)",
            transition: "transform 0.15s",
          }}
          onMouseEnter={(o) => {
            o.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(o) => {
            o.currentTarget.style.transform = "none";
          }}
        >
          Aceitar
        </button>
      </div>
    </div>
  );
}
